import { VairUser } from 'constants/payloads/vair/playerSearch';

export const DEFAULT_VAIR_SPORT = 'pickleball';

/**
 * VAIR Pro status is per-sport, not member-level — a Pro in pickleball is not a
 * Pro in padel. A VAIR Pro *is* the rater (the legacy `isRater` flag is an alias
 * VAIR plans to remove, so don't read it).
 *
 * `isVairPro` is already false while `isVairProStatus` is PENDING (paid but not
 * yet approved to rate), so gating on it alone is safe — confirmed with VAIR.
 */
export const getIsVairPro = (
  vairUser: VairUser | null | undefined,
  sport: string = DEFAULT_VAIR_SPORT,
): boolean => vairUser?.sport?.[sport]?.isVairPro ?? false;

/** Whether the player has a verified (non-recreational) rating in this sport. */
export const getIsVairified = (
  vairUser: VairUser | null | undefined,
  sport: string = DEFAULT_VAIR_SPORT,
): boolean => vairUser?.sport?.[sport]?.isVairified ?? false;
